export default "__VITE_ASSET__0521002e__"